import { FC } from 'react';

import { Document, Share, SharesTitle } from 'types';
import PartnerSharesTableRow from './PartnerSharesTableRow';

type PartnerSharesTableBodyProps = {
  partnerId: string;
  shares: Share[];
  sharesTitles: SharesTitle[];
  currentPage: number;
  rowsPerPage: number;
  isCoOwner?: boolean;
  societySharesTitleDocument?: Document;
  fetchPartnerData: () => void;
};

const PartnerSharesTableBody: FC<PartnerSharesTableBodyProps> = ({
  partnerId,
  shares,
  sharesTitles,
  societySharesTitleDocument,
  currentPage,
  rowsPerPage,
  isCoOwner = false,
  fetchPartnerData,
}: PartnerSharesTableBodyProps) => {
  const firstItemIndex = (currentPage - 1) * rowsPerPage + 1;

  return (
    <tbody>
      {shares?.map((share: Share, index: number) => (
        <PartnerSharesTableRow
          // eslint-disable-next-line react/no-array-index-key
          key={`share-${index}`}
          partnerId={partnerId}
          index={index + firstItemIndex}
          share={share}
          sharesTitles={sharesTitles}
          societySharesTitleDocument={societySharesTitleDocument}
          isCoOwner={isCoOwner}
          fetchPartnerData={fetchPartnerData}
        />
      ))}
    </tbody>
  );
};

export default PartnerSharesTableBody;
